module.exports = __webpack_public_path__ + "img/app_churn_management.aebd0c67.svg";